import { Route, Routes } from 'react-router';

import { useUsers } from '@/models/user';
import { USERS_PER_PAGE, UsersTable } from '@/routes/SettingsBeta/components/UsersTable';

import { Filters } from './Filters/Filters';
import { FiltersStateContext, useFiltersState } from './Filters/FiltersState';
import { User } from './User/User';

export const UsersRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Users />} />
      <Route path="/:id/*" element={<User />} />
    </Routes>
  );
};

const Users = () => {
  const filters = useFiltersState();

  const {
    data: { users, meta } = {},
    isLoading,
    isPlaceholderData,
    isError,
  } = useUsers(
    {
      limit: USERS_PER_PAGE,
      offset: (filters.page.page - 1) * USERS_PER_PAGE,
      search: filters.search.debouncedSearch || undefined,
      roleIds: filters.roles.roles.map(({ id }) => id),
      entityIds: filters.entities.entities.map(({ id }) => id),
    },
    { keepPreviousData: true }
  );

  return (
    <main style={{ gap: '1rem' }}>
      <FiltersStateContext value={filters}>
        <Filters />
      </FiltersStateContext>
      <UsersTable
        users={users ?? []}
        isLoading={isLoading || !!isPlaceholderData}
        isError={isError}
        page={filters.page.page}
        onPageChange={filters.page.setPage}
        count={meta?.count}
      />
    </main>
  );
};
